module.exports = __webpack_public_path__ + "static/media/intro.4c453636.mp3";